import React from 'react';
import { StyledAutocompleteBlue } from '../components/styled_autocomplete';
import { TextField, Typography} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setPackshots, setSelectedSku, setSkus } from '../../store/ShelfView/conflictsPage';
import axios from 'axios';

const NestedDropDownGlobalSearch = (props) => {
    const dispatch=useDispatch();

    const {brands,variants, flavours,weights,skus,packshots,selectedBrand,selectedVariant,selectedWeight,selectedFlavour,selectedSku}=useSelector((state)=>state.conflictsPageStore);
    const handleChange =async(value,name)=>{
        if(name==="project")
        {
            dispatch(setSkus([]))
            dispatch(setSelectedSku(null))
            const response= await axios.post("/getAllData/get_skus_acc_to_project",{project:value})
            dispatch(setSkus(response.data))
           
        }
        if(name==="skus"){
            dispatch(setSelectedSku(value));
            dispatch(setPackshots([]))
            axios.post("/getAllData/get_packshots",{skus:value}).then((response)=>{
              dispatch(setPackshots(response.data))
            }).catch((err)=>{
              console.log(err)
            })
           }
    }
    const useAutoCompleteStyles = makeStyles({
        option: {
          fontSize: '0.875rem',
          
        },
      });
      const autocomplete_classes = useAutoCompleteStyles();
      const projects=[
        "p&g", "p&g_india","null"
      ]
  return (
    <div style={{display:"flex",gap:"0.7rem",flexWrap:"wrap",marginBottom:"2rem"}}>

<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"}}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    // value={selectedBrand}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={projects}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a brand`}
        label="Project"
      />
    )}
    onChange={(event, value) => handleChange(value, 'project')}
  />
   {skus.length>0&&<StyledAutocompleteBlue
    sx={{ width: '30%',marginBottom:"1rem"  }}
    classes={{
      option: autocomplete_classes.option
    }}
    id='size-small-outlined-multi'
    size='small'
    noOptionsText='Loading...'
    value={selectedSku}
    componentsProps={{ popper: { style: { minWidth: '16rem' } } }}
    options={skus}
    getOptionLabel={option => option}
    renderInput={params => (
      <TextField
        {...params}
        variant='outlined'
        placeholder={`Select a skus`}
        label="Skus"
      />
    )}
    onChange={(event, value) => handleChange(value, 'skus')}
  />}
  </div>
  )
}

export default NestedDropDownGlobalSearch